import { render } from "./PatientDetail.vue?vue&type=template&id=0d61a33e&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"

import "./PatientDetail.vue?vue&type=style&index=0&id=0d61a33e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d61a33e"]])

export default __exports__